import { createAction } from "redux-actions"
import { GET_NOTIFICATIONS, SET_NOTIFICATIONS } from "../names"

export const getNotifications = createAction(GET_NOTIFICATIONS)
export const setNotifications = createAction(SET_NOTIFICATIONS)
